/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ErrorDto from '../model/ErrorDto';
import ErrorResponse from '../model/ErrorResponse';
import PaginatedRolesDto from '../model/PaginatedRolesDto';
import RoleDto from '../model/RoleDto';
import RoleInputDto from '../model/RoleInputDto';

/**
* Role service.
* @module api/RoleApi
* @version v0
*/
export default class RoleApi {

    /**
    * Constructs a new RoleApi. 
    * @alias module:api/RoleApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createRole operation.
     * @callback module:api/RoleApi~createRoleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RoleDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new role
     * @param {module:model/RoleInputDto} roleInputDto 
     * @param {module:api/RoleApi~createRoleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RoleDto}
     */
    createRole(roleInputDto, callback) {
      let postBody = roleInputDto;
      // verify the required parameter 'roleInputDto' is set
      if (roleInputDto === undefined || roleInputDto === null) {
        throw new Error("Missing the required parameter 'roleInputDto' when calling createRole");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = RoleDto;
      return this.apiClient.callApi(
        '/api/private/role', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteRoleById operation.
     * @callback module:api/RoleApi~deleteRoleByIdCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a role by ID
     * @param {Number} id ID of the role to delete
     * @param {module:api/RoleApi~deleteRoleByIdCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteRoleById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteRoleById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/role/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRoleById operation.
     * @callback module:api/RoleApi~getRoleByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RoleDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a role by ID
     * @param {Number} id ID of the role to update
     * @param {module:api/RoleApi~getRoleByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RoleDto}
     */
    getRoleById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getRoleById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = RoleDto;
      return this.apiClient.callApi(
        '/api/private/role/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRoles operation.
     * @callback module:api/RoleApi~getRolesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedRolesDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all roles
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page number
     * @param {Number} opts.limit Number of items per page
     * @param {module:api/RoleApi~getRolesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedRolesDto}
     */
    getRoles(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'limit': opts['limit']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = PaginatedRolesDto;
      return this.apiClient.callApi(
        '/api/private/role', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateRoleById operation.
     * @callback module:api/RoleApi~updateRoleByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RoleDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing role
     * Update an existing role by ID
     * @param {Number} id ID of the role to update
     * @param {module:model/RoleDto} roleDto 
     * @param {module:api/RoleApi~updateRoleByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RoleDto}
     */
    updateRoleById(id, roleDto, callback) {
      let postBody = roleDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateRoleById");
      }
      // verify the required parameter 'roleDto' is set
      if (roleDto === undefined || roleDto === null) {
        throw new Error("Missing the required parameter 'roleDto' when calling updateRoleById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = RoleDto;
      return this.apiClient.callApi(
        '/api/private/role/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
